(() => {
  'use strict';
  let cleanup;
  function init() {
    cleanup?.();
    const data = document.getElementById('renowa-gallery-data');
    if (!data) return;
    const root = data.closest('.shopify-section');
    const $ = id => root.querySelector(`#${id}`);
    const all = selector => [...root.querySelectorAll(selector)];
    const controller = new AbortController();
    const on = (el, event, fn, options = {}) => el?.addEventListener(event, fn, { ...options, signal: controller.signal });
    cleanup = () => { controller.abort(); document.body.classList.remove('modal-open'); };
    const images = JSON.parse(data.textContent);
    const dialogs = all('dialog');
    let index = 0;
    function sticky() {
      const rect = $('add-to-cart').getBoundingClientRect();
      $('sticky-buy').hidden = (rect.bottom > 0 && rect.top < innerHeight) || dialogs.some(d => d.open);
    }
    function openDialog(id) {
      dialogs.forEach(d => { if (d.open) d.close(); });
      $(id).showModal(); document.body.classList.add('modal-open'); sticky();
    }
    dialogs.forEach(d => {
      on(d, 'close', () => { document.body.classList.toggle('modal-open', dialogs.some(x => x.open)); sticky(); });
      on(d, 'click', e => {
        const r = d.getBoundingClientRect();
        if (e.target === d && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) d.close();
      });
    });
    all('[data-close]').forEach(b => on(b, 'click', () => b.closest('dialog').close()));
    on($('open-menu'), 'click', () => openDialog('menu-dialog'));
    all('#menu-dialog a').forEach(a => on(a, 'click', () => $('menu-dialog').close()));
    function syncZoom() { $('zoom-photo').src = images[index].full; $('zoom-photo').alt = images[index].alt; }
    function showImage(next) {
      index = (next + images.length) % images.length;
      const img = images[index];
      $('main-photo').src = img.src; $('main-photo').alt = img.alt;
      $('photo-caption').textContent = img.caption;
      $('photo-counter').textContent = `${String(index + 1).padStart(2, '0')} / ${String(images.length).padStart(2, '0')}`;
      $('zoom-counter').textContent = `${index + 1} / ${images.length}`;
      if ($('gallery-dialog').open) syncZoom();
      all('.thumb').forEach(b => {
        const active = Number(b.dataset.image) === index;
        b.classList.toggle('active', active); b.setAttribute('aria-pressed', String(active));
        if (active) {
          const strip = b.parentElement;
          const offset = b.getBoundingClientRect().left - strip.getBoundingClientRect().left;
          if (offset < 0 || offset + b.offsetWidth > strip.clientWidth) strip.scrollLeft += offset - (strip.clientWidth - b.offsetWidth) / 2;
        }
      });
    }
    function openGallery() { syncZoom(); openDialog('gallery-dialog'); }
    all('[data-image]').forEach(b => on(b, 'click', () => { showImage(Number(b.dataset.image)); if (b.hasAttribute('data-enlarge')) openGallery(); }));
    let suppressClickUntil = 0;
    on($('open-gallery'), 'click', () => { if (Date.now() > suppressClickUntil) openGallery(); });
    on($('zoom-button'), 'click', openGallery);
    for (const id of ['gallery-prev', 'previous-image']) on($(id), 'click', () => showImage(index - 1));
    for (const id of ['gallery-next', 'next-image']) on($(id), 'click', () => showImage(index + 1));
    on($('gallery-dialog'), 'keydown', e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); showImage(index + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    let touchStart;
    on($('main-photo'), 'touchstart', e => { touchStart = {x: e.touches[0].clientX, y: e.touches[0].clientY}; }, {passive:true});
    on($('main-photo'), 'touchend', e => {
      if (!touchStart) return;
      const dx = e.changedTouches[0].clientX - touchStart.x, dy = e.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { suppressClickUntil = Date.now() + 600; showImage(index + (dx < 0 ? 1 : -1)); }
      touchStart = null;
    }, {passive:true});
    on($('main-photo'), 'touchcancel', () => { touchStart = null; });
    all('[data-info]').forEach(b => on(b, 'click', () => {
      const source = root.querySelector(`[data-content="${b.dataset.info}"]`);
      $('info-title').textContent = source.querySelector('h2').textContent;
      $('info-body').replaceChildren(...[...source.children].filter(n => n.tagName !== 'H2').map(n => n.cloneNode(true)));
      openDialog('info-dialog');
    }));
    on($('market'), 'change', () => $('market').form.requestSubmit());
    all('[data-market]').forEach(b => on(b, 'click', () => { $('market').value = b.dataset.market; $('market').form.requestSubmit(); }));
    function setQuantity(value) {
      const quantity = $('quantity');
      if (!quantity) return;
      quantity.value = Math.max(1, Math.floor(Number(value) || 1));
      $('decrease').disabled = Number(quantity.value) <= 1;
    }
    on($('decrease'), 'click', () => setQuantity(Number($('quantity').value) - 1));
    on($('increase'), 'click', () => setQuantity(Number($('quantity').value) + 1));
    on($('quantity'), 'change', e => setQuantity(e.target.value));
    on($('sticky-add'), 'click', () => $('purchase-form')?.requestSubmit($('add-to-cart')));
    on($('variant-id'), 'change', e => {
      const option = e.target.selectedOptions[0];
      const available = option.dataset.available === 'true';
      window.RenowaMoney.set($('product-price'), option.dataset.priceCents, option.dataset.price);
      window.RenowaMoney.charge(root, option.dataset.priceCents);
      window.RenowaMoney.set($('sticky-price'), option.dataset.priceCents, option.dataset.price);
      for (const id of ['add-to-cart','sticky-add']) { $(id).disabled = !available; $(id).textContent = available ? 'Add to cart' : 'Sold out'; }
    });
    on(window, 'scroll', sticky, {passive:true}); on(window, 'resize', sticky);
    setQuantity(1); showImage(0); sticky();
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', e => { if (e.target.querySelector('#renowa-gallery-data')) cleanup?.(); });
})();
